

<template>
  <div class="topUpApplication">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>商户名称：</span>
          <div>
            <el-select v-model="companyValue" placeholder="请选择">
              <el-option
                v-for="item in CompanyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span>创建时间：</span>
          <el-date-picker
            v-model="merchantsTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
        <div class="item">
          <span>状态：</span>
          <div>
            <el-select v-model="statusValue" placeholder="请选择">
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 50px;"></span>
          <el-button type="primary" @click="search" size="small">搜索</el-button>
          <el-button type="danger" @click="reset" size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table :data="applicationData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column prop="id" label="充值订单号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchant_id" label="商户ID" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchantName" label="商户名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="created_at" label="申请时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="amt" label="充值金额（元）" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="auditTime" label="审核时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="auditUserName" label="审核人" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="statusName" label="状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button
                        @click="handleClick(scope.row)"
                        type="primary"
                        size="mini"
                        plain
                      >查看详情</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.status == '00'">
                      <el-button
                        @click="auditEvent(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >&emsp;审核&emsp;</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange">
            </el-pagination>
      </div>-->
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <el-dialog title="审核" :visible.sync="dialogVisible1" width="524px" :before-close="handleClose">
      <div style="width: 340px;margin: 0 auto;">
        <el-form ref="auditForm" :model="auditForm" label-width="90px">
          <el-form-item label="打款凭证：">
            <!-- <el-input v-model="form.img"></el-input> -->
            <div class="dialog-img">
              <img :src="voucherImg" alt />
            </div>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select v-model="auditForm.status" style="width:250px" placeholder="请选择">
              <el-option
                v-for="item in auditOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              resize="none"
              v-model="auditForm.remark"
            ></el-input>
          </el-form-item>
          <div>
            <el-button type="primary" @click="auditDetermine">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="查看详情"
      :visible.sync="dialogVisible2"
      width="550px"
      :before-close="handleClose"
    >
      <div class="dialog2-header">
        <div>
          <span>商户ID：{{payList.merchant_id}}</span>
          <span>{{payList.merchantName}}</span>
        </div>
        <div>
          <span>创建时间：{{payList.created_at}}</span>
          <span>充值金额：{{payList.amt_y}}元</span>
        </div>
        <div>
          <span>状态：{{payList.statusName}}</span>
          <span>审核人：{{payList.auditUserName}}</span>
        </div>
        <div>
          <span style="width: 100%">备注：{{payList.remark}}</span>
        </div>
      </div>
      <div class="dialog2-content">
        <div>充值凭证：</div>
        <div class="right">
          <img :src="payList.voucher" alt />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      companyValue: "",
      dialogVisible1: false,
      dialogVisible2: false,
      total: null,
      pageSize: 10,
      applicationData: [],
      merchantsTime: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      statusValue: "",
      stateOptions: [
        {
          value: "00",
          label: "待审核"
        },
        {
          value: "10",
          label: "已入账"
        },
        {
          value: "20",
          label: "审核失败"
        }
      ],
      CompanyOptions: [
        {
          value: "司机宝",
          label: "司机宝"
        }
      ],
      auditOptions: [
        {
          value: "10",
          label: "已入账"
        },
        {
          value: "20",
          label: "审核失败"
        }
      ],
      value: "",
      voucherImg: "",
      auditForm: {
        id: "",
        status: "",
        remark: ""
      },
      payList: {}
    };
  },
  mounted() {
    this.CompanyOptions = JSON.parse(localStorage.getItem("nameList")) || [];
    this.rechargeListPost();
  },
  methods: {
    auditDetermine() {
      post(api.rechargeAudit, this.auditForm).then(
        d => {
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.auditForm = {
              id: "",
              status: "",
              remark: ""
            };
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.dialogVisible1 = false;
            this.rechargeListPost();
          }
        },
        err => {
          //error callback
        }
      );
    },
    auditEvent(obj) {
      this.dialogVisible1 = true;
      this.auditForm.id = obj.id;
      this.voucherImg = obj.voucher;
    },
    // currentChange(size) {
    //   console.log(size)
    //   this.rechargeListPost(size)
    // },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条aaaaa`);
      this.pageSize = val;
      this.rechargeListPost();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.rechargeListPost(val);
    },
    // 重置
    reset() {
      this.statusValue = "";
      this.companyValue = "";
      this.merchantsTime = ["", ""];
      this.rechargeListPost();
    },
    search() {
      // console.log(this.statusValue)
      // console.log(this.merchantsTime)
      if (this.merchantsTime.length == 0) {
        // console.log('空的')
        this.merchantsTime = ["", ""];
      }
      this.rechargeListPost();
    },
    // 列表
    rechargeListPost(size) {
      const loading = this.$loading({
        lock: true,
        spinner: 'loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.rechargeList, {
        currentPage: size || 1,
        pageSize: this.pageSize,
        merchantId: this.companyValue,
        createdBegin: this.merchantsTime[0],
        createdEnd: this.merchantsTime[1],
        status: this.statusValue
      }).then(
        d => {
          console.log(d.status);
           loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.applicationData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    // 查看详情
    handleClick(row) {
      console.log(row);
      this.payList = row;
      this.dialogVisible2 = true;
    },
    handleClose(done) {
      done();
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.topUpApplication {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 81px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
  .dialog-img {
    width: 250px;
    height: 108px;
    background: rgba(216, 216, 216, 1);
    border-radius: 4px;
    opacity: 0.28;
    border: 1px solid rgba(121, 121, 121, 1);
  }
  .dialog2-header {
    width: 100%;
    max-width: 460px;
    margin: 0 auto;
    min-height: 133px;
    background: rgba(244, 244, 244, 0.78);
    border-radius: 6px;
    text-align: left;
    padding: 20px;
    box-sizing: border-box;
    span {
      display: inline-block;
      width: 50%;
      line-height: 24px;
    }
  }
  .dialog2-content {
    width: 100%;
    max-width: 439px;
    margin: 0 auto;
    height: 97px;
    margin-top: 20px;
    div {
      float: left;
    }
    .right {
      float: right;
      width: 359px;
      height: 97px;
      background: rgba(216, 216, 216, 0.29);
      border-radius: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/financial/money/topUpApplication.vue